/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IMixGenes, IMixGenesInterface } from "../IMixGenes";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence1",
        type: "uint32[72]",
      },
      {
        internalType: "uint32[72]",
        name: "geneticSequence2",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "mixGenes",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IMixGenes__factory {
  static readonly abi = _abi;
  static createInterface(): IMixGenesInterface {
    return new utils.Interface(_abi) as IMixGenesInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IMixGenes {
    return new Contract(address, _abi, signerOrProvider) as IMixGenes;
  }
}
